import { useKeyboardEvents as t } from "../../../hooks/useKeyboardEvents.js";
const f = ({
  ref: r,
  disabled: e = !1,
  onToggle: o
}) => {
  t({
    ref: r,
    onEnter: () => {
      e || o();
    },
    onSpace: () => {
      e || o();
    }
  });
};
export {
  f as useCheckboxKeyboardEvent
};
